
import { Check, Pencil, CreditCard, Mail, UserCircle2, DollarSign } from "lucide-react"

interface FormProgressProps {
  currentStep: number
  totalSteps: number
  showPayment?: boolean
}

export function FormProgress({ currentStep, totalSteps }: FormProgressProps) {
  const steps = [
    { number: 1, title: "Your Information", icon: UserCircle2 },
    { number: 2, title: "Recipient Information", icon: Mail },
    { number: 3, title: "Describe Situation", icon: Pencil },
    { number: 4, title: "Payment", icon: DollarSign },
    { number: 5, title: "Edit & Publish Letter", icon: Pencil }
  ]

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center">
        {steps.map((step, index) => {
          const StepIcon = step.icon
          const isComplete = currentStep > step.number
          const isCurrent = currentStep === step.number

          return (
            <div key={step.number} className="flex flex-col items-center flex-1">
              <div className="flex items-center w-full">
                <div className={`relative flex items-center justify-center w-8 h-8 rounded-full border-2 
                  ${isComplete ? 'bg-[#29b554] border-[#29b554]' : 
                    isCurrent ? 'border-[#29b554] bg-white' : 
                    'border-gray-300 bg-white'}`}>
                  {isComplete ? (
                    <Check className="w-4 h-4 text-white" />
                  ) : (
                    <StepIcon className={`w-4 h-4 ${isCurrent ? 'text-[#29b554]' : 'text-gray-400'}`} />
                  )}
                </div>
                {index < steps.length - 1 && (
                  <div className={`flex-1 h-0.5 mx-2 ${isComplete ? 'bg-[#29b554]' : 'bg-gray-300'}`} />
                )}
              </div>
              <span className={`mt-2 text-xs text-center whitespace-normal w-20 h-8 flex items-center justify-center
                ${isCurrent ? 'text-[#29b554] font-medium' : 'text-gray-500'}`}>
                {step.title}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
